import React, { Component } from 'react';

class CommunityPage extends Component {
    render() {
        return (
            <div className="Community">
                Julie, Rob, MoMack
            </div>
        );
    }
}

export default CommunityPage;
